import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notes-overview" }
const _hoisted_2 = { class: "notes-overview__content" }

import { ref } from 'vue'

import EditNoteForm from './EditNoteForm.vue'
import NotesHeader from './NotesHeader.vue'
import NotesList from './NotesList.vue'
import type { UserGender } from '@/types/app-data/user.types'

/** Base structure for a note */
interface NoteBase {
  title: string
  body: string
  last_edit?: {
    date: number
    user: {
      username: string
      firstname: string
      lastname: string
      email: string
    }
  }
}

/** Payload for saving/deleting a note */
interface NotePayload extends NoteBase {
  type: string
}

/** Note as received from props (with nested type) */
interface NoteType extends NoteBase {
  type: {
    name: string
  }
}

interface NotesOverviewProps {
  picture?: string
  vip: boolean
  highRisk: boolean
  gender: UserGender
  name: string
  notes: NoteType[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotesOverview',
  props: {
    picture: { default: '' },
    vip: { type: Boolean, default: false },
    highRisk: { type: Boolean, default: false },
    gender: { default: 'other' },
    name: { default: '' },
    notes: { default: () => [] }
  },
  emits: ["save-note", "delete-note", "should-close-without-saving"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit

const currentNote = ref<NotePayload | null>(null)

const createNewNote = () => {
  currentNote.value = { title: '', body: '', type: 'free' }
}

const closeOpenNote = () => {
  currentNote.value = null
}

const openNote = (note: NoteType) => {
  currentNote.value = { ...note, type: note.type.name }
}

const saveNote = () => {
  if (!currentNote.value) return
  emit('save-note', currentNote.value)
  closeOpenNote()
}

const deleteNote = (note: NotePayload) => {
  emit('delete-note', note)
}

const shouldCloseWithoutSaving = () => {
  emit('should-close-without-saving')
}

/**
 * Generic handler to update a field of the current note.
 * @param key The field name to update ('title' or 'body')
 * @param value The new value for the field
 */
const updateCurrentNoteField = (key: 'title' | 'body', value: string) => {
  if (!currentNote.value) return

  currentNote.value[key] = value
}

__expose({ closeOpenNote })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NotesHeader, {
      picture: __props.picture ?? '',
      gender: __props.gender,
      vip: __props.vip,
      "high-risk": __props.highRisk,
      name: __props.name,
      onClose: shouldCloseWithoutSaving
    }, null, 8, ["picture", "gender", "vip", "high-risk", "name"]),
    _createElementVNode("div", _hoisted_2, [
      (currentNote.value)
        ? (_openBlock(), _createBlock(EditNoteForm, {
            key: 0,
            "title-value": currentNote.value.title,
            "body-value": currentNote.value.body,
            "last-edit": currentNote.value.last_edit,
            "note-type": currentNote.value.type,
            onTitle: _cache[0] || (_cache[0] = value => updateCurrentNoteField('title', value)),
            onBody: _cache[1] || (_cache[1] = value => updateCurrentNoteField('body', value)),
            onCancel: closeOpenNote,
            onSubmitForm: saveNote
          }, null, 8, ["title-value", "body-value", "last-edit", "note-type"]))
        : (_openBlock(), _createBlock(NotesList, {
            key: 1,
            notes: __props.notes,
            onOpenNote: openNote,
            onNewNote: createNewNote,
            onDeleteNote: deleteNote
          }, null, 8, ["notes"]))
    ])
  ]))
}
}

})